import { useEffect } from 'react';

export const DynatraceRum = () => {
  useEffect(() => {
    // Don't load if no ID configured or running locally
    if (!process.env.REACT_APP_DYNATRACE_ID || window.location.hostname === 'localhost') {
      return undefined;
    }

    const scriptUrl = 'https://js-cdn.dynatrace.com/jstag/185a0521924/bf64175enq/'
      + process.env.REACT_APP_DYNATRACE_ID
      + '_complete.js';

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptUrl;
    script.crossOrigin = 'anonymous';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default DynatraceRum;
